/**
 * @flow
 */

import React, { Component } from 'react'

import { ResponsiveContainer } from '../common/styledComponents'
import { scrollToEventsSection } from '../../../utils/navigationUtils'
import {
  LandingSectionContainer,
  SectionWrapper,
  Heading,
  HeadingDescription,
  ButtonDescription,
  ButtonContainer
} from './styledComponents'
import { EnquireNowButtonContainer } from '../EventsDescriptionSection/components/Section/styledComponents'
import EnquireNowButton from '../common/EnquireNowButton'

class LandingPage extends Component {
  render() {
    const { eventsLandingSection } = this.props
    const {
      sectionId,
      title,
      backgroundImageUrl,
      mobileBackgroundImageUrl,
      buttonText,
      titleDescription
    } = eventsLandingSection
    return (
      <LandingSectionContainer
        id={sectionId}
        desktopBackgroundImage={backgroundImageUrl}
        mobileBackgroundImage={mobileBackgroundImageUrl}
      >
        <ResponsiveContainer>
          <SectionWrapper>
            <HeadingDescription>{titleDescription}</HeadingDescription>
            <Heading
              dangerouslySetInnerHTML={{
                __html: title
              }}
              as="h1"
            />
            <EnquireNowButtonContainer>
              <EnquireNowButton
                id={'events-landing-section-get-in-touch-button'}
              />
            </EnquireNowButtonContainer>
          </SectionWrapper>
        </ResponsiveContainer>
      </LandingSectionContainer>
    )
  }
}

export default LandingPage



// WEBPACK FOOTER //
// ./src/components/Events/LandingPage/index.js